document.addEventListener('DOMContentLoaded', () => {

  const faqItems = document.querySelectorAll('.faq-item');
  const sidebarTags = document.querySelectorAll('.faq-tag');
  const categoryPs = document.querySelectorAll('.faq-category');
  const dropdown = document.querySelector('.faq-dropdown');
  const dropdownSelected = document.querySelector('.faq-dropdown-selected');
  const dropdownItems = document.querySelectorAll('.faq-dropdown-item');
  const stickyElements = document.querySelectorAll('.faq-sidebar, .faq-category');
  let lastScrollTop = 0;
  let ticking = false;
  let userSelectedDropdown = false;
  let ignoreScroll = false;
  function isMobile() {
    return window.innerWidth <= 749;
  }
  function getHeaderHeight() {
    const header = document.querySelector('.header');
    return header ? header.offsetHeight : (isMobile() ? 52 : 63);
  }
  function openOnly(item) {
    faqItems.forEach(i => i.classList.remove('active'));
    if (item) item.classList.add('active');
  }
  function getScrollOffset(isDropdownScroll = false) {
    let offset = getHeaderHeight();
    if (isMobile() && isDropdownScroll && dropdown) {
      offset += dropdown.offsetHeight + 10;
    }
    return offset;
  }
  function scrollToItem(item, isDropdownScroll = false) {
    if (!item) return;
    const elementPosition = item.getBoundingClientRect().top + window.pageYOffset;
    const offset = getScrollOffset(isDropdownScroll);
    window.scrollTo({
      top: elementPosition - offset,
      behavior: 'smooth'
    });
  }
  window.addEventListener('scroll', () => {
    if (!ticking) {
      window.requestAnimationFrame(() => {
        const currentScroll = window.pageYOffset;
        stickyElements.forEach(el => {
          if (currentScroll > lastScrollTop) {
            el.style.top = '0px';
          } else {
            el.style.top = getHeaderHeight() - 2 + 'px';
          }
        });
        lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
        updateActiveOnScroll();
        ticking = false;
      });
      ticking = true;
    }
  });
  function setActiveSidebar(targetId) {
  sidebarTags.forEach(tag => {
    tag.classList.toggle('active', tag.dataset.target === targetId);
  });
}
  // Active state on scroll
  function updateActiveOnScroll() {
    if (ignoreScroll) return;
    let currentActiveId = null;
    categoryPs.forEach(cat => {
      const rect = cat.getBoundingClientRect();
      if (rect.top <= getHeaderHeight() + 20) {
        currentActiveId = cat.id;
      }
    });
    if (!currentActiveId) {
      if (!userSelectedDropdown && dropdownSelected) {
        dropdownSelected.textContent = 'Choose a topic';
      }
      return;
    }
    // Sidebar active
    sidebarTags.forEach(tag => {
      tag.classList.toggle('active', tag.dataset.target === currentActiveId);
    });
    // Dropdown active sync
    if (!userSelectedDropdown && dropdownSelected) {
      let found = false;
      dropdownItems.forEach(item => {
        if (item.dataset.target === currentActiveId) {
          item.classList.add('active');
          dropdownSelected.textContent = item.textContent;
          found = true;
        } else {
          item.classList.remove('active');
        }
      });
      if (!found) dropdownSelected.textContent = 'Choose a topic';
    }
  }
  // Sidebar click (desktop)
  sidebarTags.forEach(tag => {
  tag.addEventListener('click', () => {
    if (isMobile()) return;

    const targetId = tag.dataset.target;
    const target = document.getElementById(targetId);
    if (!target) return;

    // 🔴 STOP scroll interference
    ignoreScroll = true;

    // ✅ DIRECT active set karo (no jumping)
    setActiveSidebar(targetId);

    const nextFAQ = target.nextElementSibling?.querySelector('.faq-item');
    openOnly(nextFAQ);

    scrollToItem(target);

    // 🟢 thoda delay ke baad scroll wapas allow
    setTimeout(() => {
      ignoreScroll = false;
    }, 600);
  });
});
  //  Category click
  categoryPs.forEach(cat => {
    cat.addEventListener('click', () => {
      const nextFAQ = cat.nextElementSibling?.querySelector('.faq-item');
      openOnly(nextFAQ);
      scrollToItem(cat);
    });
  });
  //  Dropdown (mobile)
  if (dropdown && dropdownSelected) {
    dropdownSelected.addEventListener('click', (e) => {
      e.stopPropagation();
      if (!isMobile()) return;
      dropdown.classList.toggle('open');
    });
    dropdownItems.forEach(item => {
      item.addEventListener('click', (e) => {
        e.stopPropagation();
        if (!isMobile()) return;
        const targetId = item.dataset.target;
        const target = document.getElementById(targetId);
        if (!target) return;
        dropdownItems.forEach(i => i.classList.remove('active'));
        item.classList.add('active');
        userSelectedDropdown = true;
        ignoreScroll = true;
        setTimeout(() => {
          ignoreScroll = false;
        }, 500);
        dropdownSelected.textContent = item.textContent;
        dropdown.classList.remove('open');
        const nextFAQ = target.nextElementSibling?.querySelector('.faq-item');
        openOnly(nextFAQ);
        scrollToItem(target, true);
      });
    });
    document.addEventListener('click', () => {
      dropdown.classList.remove('open');
    });
  }
  //  FAQ toggle
  faqItems.forEach(item => {
    const question = item.querySelector('.question');
    if (question) {
      question.addEventListener('click', () => {
        faqItems.forEach(i => i.classList.remove('active'));
        item.classList.toggle('active');
      });
    }
  });
});